class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = this.closest(".section--header");
    this.__headerOffSet = 39;
    this.__spaceIfReviewsBarEnabled = 29;
    this.announcementBar = document.querySelector(
      "#shopify-section-announcement-bar",
    );
    this.reviewsBar = document.querySelector("#topbar-reviews");
    this.predictiveSearch = this.querySelector("predictive-search");
    if (
      this.announcementBar &&
      !this.announcementBar
        .querySelector("announcement-bar")
        .classList.contains("announcement-empty")
    ) {
      document.body.classList.add("announcement-bar-active");
      document.body.style.setProperty(
        "--announce-offset",
        this.announcementBar.offsetHeight - 4 + "px",
      );
    }
    if (this.reviewsBar) {
      document.body.classList.add("reviews-bar-active");
    }
    this.enableStickyHeader = [true, "true"].includes(
      this.dataset.enableStickyHeader,
    );
    this.scrollingBack = false;
    this.toggleReverseAnimation = false;
    this.route = window.location.pathname;
    if (this.route != "/") {
      this.route = window.location.pathname + "/";
    }

    const headerOffset = 86 + this.announcementBar?.offsetHeight + "px";
    document.body.style.setProperty(
      "--header-translate",
      -(74 + this.announcementBar?.offsetHeight) + "px",
    );
    if (this.reviewsBar) {
      const homePageMenuSpace = document.body.classList.contains(
        "template--index",
      )
        ? 3
        : 0;
      document.body.style.setProperty(
        "--header-translate",
        -(
          this.__spaceIfReviewsBarEnabled +
          homePageMenuSpace +
          this.__headerOffSet
        ) + "px",
      );
    }

    document.body.style.setProperty(
      "--header-translate-top",
      this.__headerOffSet + "px",
    );
    if (this.reviewsBar) {
      document.body.style.setProperty(
        "--header-translate-top",
        this.__headerOffSet + this.__spaceIfReviewsBarEnabled + "px",
      );
    }
    document.body.style.setProperty("--header-offset", headerOffset);
    if (this.route === window.Shopify.routes.root) {
      this.header.classList.add("shopify-section-header-sticky");
      document.body.classList.add("animated-header");
      this.announcementBar &&
        this.announcementBar.classList.add(
          "shopify-section-header-sticky-pre",
          "pointer-events-none",
        );
    } else {
      this.header.classList.add("fixed-header");
      this.header.classList.remove("shopify-section-header-sticky");
    }
    this.announcementBar = document.querySelector("announcement-bar");
    this.isTransparent = this.hasAttribute("data-transparent");
    this.dropdownLinks = this.querySelectorAll("[data-expand-on-hover]");
    this.overlay = this.querySelector("[data-overlay]");
    this.headerInner = this.querySelector(".header__inner");
    this.headerOffset =
      (document.querySelector(".section--announcement-bar")?.offsetHeight ||
        0) + 74;

    this.setHeaderOffset();

    this.onScrollHandler = this.onScroll.bind(this);

    if (this.route === window.Shopify.routes.root && window.scrollY > 300) {
      this.header.classList.remove("reverse-header-sticky-translate");
      document.body.classList.add("--is-loaded");
      if (!this.toggleReverseAnimation) {
        this.header.classList.add("header-sticky-translate", "shift-icons");
        document.body.classList.add("header-sticky-translated");
      }
      this.header.classList.remove("shopify-section-header-hidden");
    }

    window.addEventListener("scroll", this.onScrollHandler, false);
    window.addEventListener("resize", this.setHeaderOffset.bind(this));
    this.dropdownLinks.forEach((link) => {
      // Registered ahead of the overlay listeners so the rect reads happen
      // before the overlay class write, avoiding a forced layout.
      link.addEventListener("mouseenter", () => this.setDropdownLimit(link));
      link.addEventListener("focusin", () => this.setDropdownLimit(link));
      link.addEventListener("mouseenter", (event) =>
        this.dropdownOverlayToggle(event),
      );
      link.addEventListener("mouseleave", (event) =>
        this.dropdownOverlayToggle(event),
      );
    });
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  setHeaderOffset() {
    if (!this.isTransparent) {
      return;
    }

    let offset = this.route === window.Shopify.routes.root ? 74 : 74;
    const headerInner = this.header.querySelector(".header__inner");
    const headerInnerHeight = headerInner.clientHeight || 0;
    const isAnnouncementBelow =
      this.announcementBar?.classList.contains("announcement-bar--is-bellow") ||
      false;

    offset += headerInnerHeight;

    if (isAnnouncementBelow && this.announcementBar) {
      offset += this.announcementBar.clientHeight;
      this.announcementBar.style.top = `${offset}px`;
    }

    this.header.style.marginBottom = `-${offset}px`;
  }

  onScroll() {
    if (
      !this.enableStickyHeader ||
      this.header.classList.contains("menu-open")
    ) {
      return;
    }

    let bodyTopOffset = isNaN(parseInt(document.body.style.top))
      ? 0
      : parseInt(document.body.style.top);
    let scrollTop = 0;
    if (!isNaN(bodyTopOffset) && bodyTopOffset < 0) {
      scrollTop = bodyTopOffset * -1;
    } else {
      scrollTop = window.scrollY;
    }

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    let isScrolledAfter = scrollTop > this.headerOffset;
    const isAnnouncementBelow =
      this.announcementBar?.classList.contains("announcement-bar--is-bellow") ||
      false;

    isAnnouncementBelow
      ? (isScrolledAfter = scrollTop > 0)
      : (isScrolledAfter = scrollTop > this.headerOffset);

    if (isScrolledAfter) {
      if (
        this.route === window.Shopify.routes.root &&
        this.scrollingBack &&
        !this.toggleReverseAnimation &&
        window.scrollY < 300
      ) {
        this.header.classList.remove("header-sticky-translate", "shift-icons");
        document.body.classList.remove("header-sticky-translated");
        this.header.classList.add("reverse-header-sticky-translate");
        this.scrollingBack = false;
        this.toggleReverseAnimation = true;
      }

      if (
        this.route === window.Shopify.routes.root &&
        window.scrollY > 300 &&
        !this.toggleReverse
      ) {
        this.scrollingBack = true;
        this.toggleReverseAnimation = false;
      }
      this.route === window.Shopify.routes.root &&
        document.body.classList.add("--is-loaded");

      requestAnimationFrame(this.reveal.bind(this));
      if (this.route === window.Shopify.routes.root && scrollTop > 300) {
        this.header.classList.remove("reverse-header-sticky-translate");
        if (!this.toggleReverseAnimation) {
          this.header.classList.add("header-sticky-translate", "shift-icons");
          document.body.classList.add("header-sticky-translated");
        }
        this.header.classList.remove("shopify-section-header-hidden");
      }
    } else {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.classList.toggle("is-solid", isScrolledAfter && this.isTransparent);
  }

  reveal() {
    this.header.classList.remove("shopify-section-header-hidden");
    if (this.route !== window.Shopify.routes.root) {
      this.header.classList.add("partial-header-translate");
      document.body.classList.add("partial-header-translated");
    }

    // if (this.announcementBar && !this.isTransparent) {
    //     this.announcementBar.parentElement.style[
    //         isAnnouncementBelow ? "paddingTop" : "paddingBottom"
    //     ] = `${this.header.offsetHeight}px`
    // }
  }

  reset() {
    const isAnnouncementBelow =
      this.announcementBar?.classList.contains("announcement-bar--is-bellow") ||
      false;
    this.header.classList.remove(
      "shopify-section-header-hidden",
      "animate",
      "partial-header-translate",
      "header-sticky-translate",
    );
    document.body.classList.remove("partial-header-translated");
    document.body.classList.remove("header-sticky-translated");
    if (this.route === window.Shopify.routes.root) {
      this.header.style.top = this.announcementBar?.offsetHeight + "px";
      this.toggleReverse = false;
      document.body.classList.remove("--is-loaded");
    } else {
      this.header.classList.remove(
        "partial-header-translate",
        "shopify-section-header-sticky",
      );
      document.body.classList.remove("partial-header-translated");
    }
    if (this.announcementBar) {
      this.announcementBar.parentElement.style[
        isAnnouncementBelow ? "paddingTop" : "paddingBottom"
      ] = "0px";
    }
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll("details-disclosure");
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal =
      this.searchModal || this.header.querySelector("details-modal");

    if (!this.searchModal) {
      return;
    }

    this.searchModal.close(false);
  }

  dropdownOverlayToggle(event) {
    if (!this.overlay) {
      return;
    }

    this.overlay.classList.toggle("is-visible", event.type === "mouseenter");
  }

  setDropdownLimit(item) {
    if (!this.headerInner) {
      return;
    }

    // Room from the trigger's left edge to the right edge of the content
    // column. Whether that needs a shift is decided by min() in the CSS.
    const limit =
      this.headerInner.getBoundingClientRect().right -
      item.getBoundingClientRect().left;

    item.style.setProperty("--header-dropdown-limit", `${Math.round(limit)}px`);
  }
}

customElements.define("sticky-header", StickyHeader);
